/**
 * Normalise une saisie d'objectif payout vers `number > 0` ou `null`.
 *
 * Un `0` saisi par l'utilisateur signifie « pas d'objectif », pas « objectif de 0 $ » :
 * c'est aussi le seul moyen d'effacer un objectif déjà enregistré. Sans cette
 * normalisation, `0` traversait le garde truthy du client (`"0"` est une string
 * non-vide) puis se faisait rejeter par le `.positive()` du schéma serveur —
 * l'utilisateur voyait « Une erreur est survenue » sans explication.
 */
export function normalizePayoutTarget(raw: unknown): number | null {
  if (raw === null || raw === undefined || raw === "") return null;

  const value = typeof raw === "number" ? raw : parseFloat(String(raw));

  if (!Number.isFinite(value) || value <= 0) return null;

  return value;
}
